<div class="category-chip">
    <p class="text">{{name}}</p>
    <fa-icon *ngIf="!readonly" icon="xmark" class="icon"></fa-icon>
</div>